import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../header/Header';
import Sidebar from '../sidebar/Sidebar';
import { Grid } from 'antd';
import RoutesMap from '../../route_control/RouteControl';
import FallbackPage from '../../routes/auth/FallbackPage';
import { sidebar } from '../../redux/slices/assets';
import { SessionManager, showAccessDeniedAlert, isStudent } from '../../utils';
const { useBreakpoint } = Grid;

const useAuth = () => {
    let user = SessionManager.getCookie("user_token");

    if (user) {
        try {
            if (user) {
                return user;
            }
        } catch (error) {
            return false
        }
    } else {
        return false
    }
}

const Auth = (props) => {
    const [collapsed, setCollapsed] = useState(false)
    const [drawerOpen, setDrawerOpen] = useState(false)
    const [permissionFailed, setPermissionFailed] = useState(false)
    const auth = useAuth()
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const sidebarData = useSelector(state => state?.sidebar?.data)

    const screens = useBreakpoint();
    const isMobileOrTablet = !screens.lg; // < 992px → treat as mobile

    // Permission comes from the sidebar API; the session copy covers the time before it responds
    const parsePermission = () => {
        try {
            if (sidebarData?.attributes) return sidebarData.attributes.map(val => JSON.parse(val)).flat()
            return JSON.parse(SessionManager.getSession('permission'))
        } catch (error) {
            return null
        }
    }
    const permission = permissionFailed ? [] : parsePermission()
    const permissionLoaded = Array.isArray(permission)

    const isRouteAuthorized = (isStudent() && location.pathname === RoutesMap?.STUDENT_EXAM_DETAILS?.path) || (permission && permission.some(
        (item) => item.route === location.pathname
    ));

    const user = JSON.parse(SessionManager.getCookie("user") || "{}")
    const isPaymentPending = ['pending', 'hold'].includes(String(user?.payment_status || '').toLowerCase())
    const isPaymentPage = location.pathname === RoutesMap?.PAYMENT?.path
    const isPaymentResultPage = location.pathname === RoutesMap?.PAYMENT_RESULT?.path
    const homePath = isStudent() ? RoutesMap?.STUDENT_DASHBOARD?.path : RoutesMap?.DASHBOARD?.path

    useEffect(() => {
        // Fresh tab: session is empty, so fetch the permission before deciding on the route
        if (!auth || permissionLoaded) return
        dispatch(sidebar({ navigate })).then((res) => {
            if (res?.payload?.status === 200) {
                const list = res.payload?.data?.data?.attributes?.map(val => JSON.parse(val)).flat()
                SessionManager.setSession('permission', JSON.stringify(list))
            } else {
                setPermissionFailed(true)
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth, permissionLoaded])

    if (!auth) {
        const studentLogout = SessionManager.getSession('student_logout')
        if (studentLogout) SessionManager.removeSession('student_logout')
        const onStudentPage = [
            RoutesMap?.STUDENT_DASHBOARD?.path,
            RoutesMap?.STUDENT_EXAM_LIST?.path,
            RoutesMap?.STUDENT_EXAM_INSTRUCTIONS?.path,
            RoutesMap?.STUDENT_EXAM_START?.path,
            RoutesMap?.STUDENT_EXAM_DETAILS?.path,
            RoutesMap?.STUDENT_LOGIN?.path,
        ].includes(location.pathname)
        const loginPath = (isStudent() || onStudentPage || studentLogout) ? RoutesMap?.STUDENT_LOGIN?.path : RoutesMap?.LOGIN?.path
        return <Navigate to={loginPath} replace />
    }
    else if (isPaymentPending && !isPaymentPage && !isPaymentResultPage) {
        return <Navigate to={RoutesMap?.PAYMENT?.path} replace />
    }
    else if (isPaymentResultPage || (isPaymentPending && isPaymentPage)) {
        return <Outlet />
    }
    else if (!isPaymentPending && isPaymentPage) {
        return <Navigate to={homePath} replace />
    }
    else if (!permissionLoaded) {
        return <FallbackPage />
    }
    else if (!isRouteAuthorized) {
        if (auth && location.pathname === '/') {
            return <Navigate to={homePath} />
        } else {
            showAccessDeniedAlert(navigate)
            return null;
        }
    }
    else if (location.pathname === RoutesMap?.STUDENT_EXAM_START?.path) {
        // Exam screen runs without header/sidebar so nothing else can be opened
        return <Outlet />
    }
    else {
        return (
            <div>
                <Header collapsed={collapsed} setCollapsed={setCollapsed} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} isMobileOrTablet={isMobileOrTablet} />
                <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} isMobileOrTablet={isMobileOrTablet} />
                <div className={isMobileOrTablet ? 'outlet_mobile_view' : collapsed ? "outlet_collapsed" : "outlet_not_collapsed"}>
                    <Outlet />
                </div>
            </div>
        )
    }
}

export default Auth;
